(function () {
  'use strict';

  if (window.__nestMobileCartRenderSettle20260708) return;
  window.__nestMobileCartRenderSettle20260708 = 'v1-mobile-price-extend-settle';

  var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var settleTimer = null;
  var maxTimer = null;
  var observer = null;
  var rootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container]';
  var rowSelector = '.cart-item,[data-cart-item],.cart__row,.cart__item,.ajaxcart__product,.ajax-cart__item';
  var controlSelector = [
    '.cart-modal button',
    '.cart-modal a',
    '.cart-modal input',
    '.cart-modal [role="button"]',
    '.cart-modal [data-cart-remove]',
    '.cart-modal [href*="/cart/change"]',
    '.cart-modal [name="updates[]"]',
    '.cart-modal .cart__qty',
    '.cart-modal .quantity',
    '.cart-modal .js-qty'
  ].join(',');

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 749;
  }

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function cartRoot() {
    return document.querySelector(rootSelector);
  }

  function installStyle() {
    if (document.getElementById('nest-mobile-cart-render-settle-20260708')) return;
    var style = document.createElement('style');
    style.id = 'nest-mobile-cart-render-settle-20260708';
    style.textContent = [
      '@media screen and (max-width: 749px) {',
      '  .cart-modal .cart-item-info-price,',
      '  .cart-modal .cart-item-price,',
      '  .cart-modal .cart-subtotal__price,',
      '  .cart-modal .cart-total__price,',
      '  .cart-modal .order-discount,',
      '  .cart-modal #extend-ajax-cart-offer,',
      '  .cart-modal [data-nest-extend-ajax-offer="true"] {',
      '    transition: opacity 140ms ease;',
      '  }',
      '  body.nest-mobile-cart-settling .cart-modal .cart-item-info-price,',
      '  body.nest-mobile-cart-settling .cart-modal .cart-item-price,',
      '  body.nest-mobile-cart-settling .cart-modal .cart-subtotal__price,',
      '  body.nest-mobile-cart-settling .cart-modal .cart-total__price,',
      '  body.nest-mobile-cart-settling .cart-modal .order-discount,',
      '  body.nest-mobile-cart-settling .cart-modal #extend-ajax-cart-offer,',
      '  body.nest-mobile-cart-settling .cart-modal [data-nest-extend-ajax-offer="true"] {',
      '    opacity: 0 !important;',
      '    visibility: hidden !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function extendOfferNodes(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    return Array.prototype.slice.call(root.querySelectorAll('#extend-ajax-cart-offer, [data-nest-extend-ajax-offer="true"]'));
  }

  function labelExtendOffers(scope) {
    extendOfferNodes(scope).forEach(function (node) {
      node.setAttribute('data-nest-extend-ajax-offer', 'true');
    });
  }

  function dedupeExtendOffers(scope) {
    labelExtendOffers(scope);

    var groups = [];
    extendOfferNodes(scope).forEach(function (node) {
      var row = node.closest(rowSelector) || node.parentElement || document.body;
      var group = groups.filter(function (candidate) { return candidate.row === row; })[0];
      if (!group) {
        group = { row: row, nodes: [] };
        groups.push(group);
      }
      group.nodes.push(node);
    });

    groups.forEach(function (group) {
      group.nodes.forEach(function (node, index) {
        if (index === group.nodes.length - 1) return;
        if (node.parentNode) node.parentNode.removeChild(node);
      });
    });
  }

  function startSettle(reason) {
    if (!isMobile()) return;
    installStyle();
    document.body.classList.add('nest-mobile-cart-settling');
    window.__nestMobileCartRenderSettleLastReason = reason || 'cart update';
    window.clearTimeout(settleTimer);
    window.clearTimeout(maxTimer);
    maxTimer = window.setTimeout(finishSettle, 1900);
    settleTimer = window.setTimeout(finishSettle, 520);
  }

  function bumpSettle() {
    if (!document.body.classList.contains('nest-mobile-cart-settling')) return;
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(finishSettle, 360);
  }

  function finishSettle() {
    window.clearTimeout(settleTimer);
    window.clearTimeout(maxTimer);
    dedupeExtendOffers(cartRoot() || document);
    document.body.classList.remove('nest-mobile-cart-settling');
  }

  function isCartControl(target) {
    if (!target || !target.closest) return false;
    if (!target.closest(rootSelector)) return false;
    var control = target.closest(controlSelector);
    if (!control) return false;
    var signal = clean([control.className, control.name, control.getAttribute('href'), control.getAttribute('aria-label'), control.textContent].join(' ')).toLowerCase();
    return /plus|minus|increase|decrease|remove|delete|quantity|cart|checkout|\+|-/.test(signal);
  }

  function bind() {
    installStyle();
    dedupeExtendOffers(document);

    document.addEventListener('pointerdown', function (event) {
      if (isCartControl(event.target)) startSettle('pointerdown cart control');
    }, true);
    document.addEventListener('click', function (event) {
      if (isCartControl(event.target)) startSettle('click cart control');
    }, true);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest(rootSelector)) startSettle('change cart control');
    }, true);

    ['refreshAjaxCart', 'refreshCart', 'cart:refresh'].forEach(function (eventName) {
      window.addEventListener(eventName, function () { startSettle(eventName); }, true);
    });

    if (window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        var sawCartChange = false;
        mutations.forEach(function (mutation) {
          Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && (node.matches('#extend-ajax-cart-offer') || node.matches('[data-nest-extend-ajax-offer="true"]'))) sawCartChange = true;
            if (node.querySelector && node.querySelector('#extend-ajax-cart-offer, [data-nest-extend-ajax-offer="true"]')) sawCartChange = true;
            if (node.closest && node.closest(rootSelector)) sawCartChange = true;
          });
        });
        if (sawCartChange) {
          labelExtendOffers(document);
          bumpSettle();
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
